import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';

import styles from './styles.module.css';

import Tab1 from  './components/tab1';
import Tab2 from  './components/tab2';
import Tab3 from  './components/tab3';
import Tab4 from  './components/tab4';
import Tab5 from  './components/tab5';
import LeadForm from '../../components/LeadForm'
import { submitSFLeadForm } from 'containers/App/actions';
import { selectSFLeadSubmit  } from 'containers/App/selectors';

function mapDispatchToProps(dispatch) {
  return {
    submitSFLeadForm: (values) =>dispatch(submitSFLeadForm(values))
  }
}

function mapStateToProps(state) {
  return {
    leadSubmitted: selectSFLeadSubmit(state),
  }
};

@connect(mapStateToProps, mapDispatchToProps)
@CSSModules(styles,{allowMultiple:true})
export default class OutOfNetworkPage extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
        memberCount:null,
        cleaning:null,
        exam: null,
        xray:null,
        additional:null,
        ucrCost: null,
        hygenist: null,
        supplies: null,
        doctor: null,
        misc: null,
        overheadCost:null,
        discount:null,
        writeOffOne:null,
        writeOffTwo:null,
        writeOffThree:null,
        whichStep:1,
    };
  }

  nextStep=(step)=>{
    this.setState({...this.state,whichStep:step})
  }

  changeMemberCount=(values)=>{
    let memberCount=(values.memberCount!=undefined&&values.memberCount.trim()!='')?parseFloat(values.memberCount):null;
    this.setState({...this.state,memberCount:memberCount,whichStep:2})
}

changeUCR=(values)=>{
    let cleaning=values.cleaning!=''?parseFloat(values.cleaning):0;
    let exam=values.exam!=''?parseFloat(values.exam):0;
    let xray=values.xray!=''?parseFloat(values.xray):0;
    let additional=values.additional!=''&&values.additional!=undefined?parseFloat(values.additional):0;
    let ucrCost=(2*cleaning)+(2*exam)+xray+additional;
    this.setState({...this.state,cleaning:cleaning,exam:exam,xray:xray,additional:additional,ucrCost:ucrCost,whichStep:3})
}

changeOverhead=(values)=>{
    let hygenist=values.hygenist!=''?parseFloat(values.hygenist):0;
    let supplies=values.supplies!=''?parseFloat(values.supplies):0;
    let doctor=values.doctor!=''&&values.doctor!=undefined?parseFloat(values.doctor):0;
    let misc=values.misc!=''&&values.misc!=undefined?parseFloat(values.misc):0;
    let overheadCost=2*(hygenist+supplies+doctor+misc);
    this.setState({...this.state,hygenist:hygenist,supplies:supplies,doctor:doctor,misc:misc,overheadCost:overheadCost,whichStep:4})
}

changePercent=(values)=>{
  let discount=values.discount!=undefined&&values.discount!=''?values.discount:0;
  let writeOffOne=values.writeOffOne!=undefined&&values.writeOffOne!=''?values.writeOffOne:5;
  let writeOffTwo=values.writeOffTwo!=undefined&&values.writeOffTwo!=''?values.writeOffTwo:0;
  let writeOffThree=values.writeOffThree!=undefined&&values.writeOffThree!=''?values.writeOffThree:0;
  this.setState({...this.state,discount:parseFloat(discount),writeOffOne:parseFloat(writeOffOne),writeOffTwo:parseFloat(writeOffTwo),writeOffThree:parseFloat(writeOffThree),whichStep:5})
}

changePercent2=(values)=>{
  document.getElementById("LeadForm").scrollIntoView();
}

submitOutOfNetwork=(values)=>{
  this.props.submitSFLeadForm({...values,topicId:"0TO4W000009gYsPWAU"})
}

restart=()=>{
  if(document.getElementById("jumbotron")) document.getElementById("jumbotron").scrollIntoView();
   this.setState({memberCount:null,writeOffOne:null,writeOffTwo:null,writeOffThree:null,whichStep:1})
}

  render() {


return (

  <div>
  <div styleName="container-wrapper">

      <section styleName="dark" style={{paddingTop:'40px'}}>

        <div styleName="rounded-section">

            <div styleName={this.state.whichStep==1?'s1 out-of-network-tab':'out-of-network-tab hide'}>
              {this.state.whichStep==1&&(
              <Tab1
              initialValues={this.state}
              nextStep={this.nextStep}
              changeMemberCount={this.changeMemberCount}
              />)}
             </div>

              <div styleName={this.state.whichStep==2?'s2 out-of-network-tab':'out-of-network-tab hide'}>
                {this.state.whichStep==2&&(
                <Tab2
                  initialValues={this.state}
                  nextStep={this.nextStep}
                  changeUCR={this.changeUCR}
                  />)}
              </div>

              <div styleName={this.state.whichStep==3?'s3 out-of-network-tab':'out-of-network-tab hide'}>
                {this.state.whichStep==3&&(
                <Tab3
                  initialValues={this.state}
                  nextStep={this.nextStep}
                  changeOverhead={this.changeOverhead}
                  />)}
              </div>

              <div id="sectionFour" styleName={this.state.whichStep==4?'s4 out-of-network-tab':'out-of-network-tab hide'}>
                {this.state.whichStep==4&&(
                <Tab4
                  initialValues={this.state}
                  nextStep={this.nextStep}
                  changePercent={this.changePercent}
                  />)}
              </div>

              <div id="sectionFive" styleName={this.state.whichStep==5?'out-of-network-tab':'out-of-network-tab hide'}>
                {this.state.whichStep==5&&(
                <Tab5
                  initialValues={this.state}
                  nextStep={this.nextStep}
                  changePercent2={this.changePercent2}
                  restart={this.restart}
                  />)}
              </div>

          </div>

      </section>

      {/* <section styleName="leadform">

        <div styleName="form-image">
          <div styleName="form-content">
          </div>
        </div>

        <div styleName="form-form">
          <div styleName="form-content">
              <div id="LeadForm">
              <h2>Free eBook</h2>
              <h3>UNCOMPLICATING DENTISTRY: Strategies for Going Out Of Network</h3>
              <div styleName="leadform-description">
                  <p>You've seen the math; let's go into detail about the decision process.</p>
                  <p>In this exclusive eBook, we talk about:</p>
                    <ul>
                      <li>Why you may want to drop a PPO</li>
                      <li>The simple math behind the decision</li>
                      <li>What to say to your patients to keep them around</li>
                      <li>The ultimate soft landing for out-of-network patients: in-house membership plans</li>
                    </ul>
                  <br/><br/>
                  <p>Fill out the form below to access the free download:</p>
                </div>

                {this.props.leadSubmitted==false&&(
                  <LeadForm
                  onSubmit={this.submitOutOfNetwork}
                  initialValues={{topicId:'0TO4W000009gYsPWAU'}}
                  />)}
                {this.props.leadSubmitted==true&&(
                  <div>Here you go! <br/><a href="https://s3.amazonaws.com/market_materials/DentalHQ-OutOfNetwork-dropPPOs.pdf" target="_blank">Click this link to download the eBook.</a>

                  </div>
                )}
              </div>
          </div>
        </div>
      </section> */}



</div>
{/* <div styleName="footer-dark">
    <footer>
        <div styleName="footer-container">
            <div styleName="footer-row">
                <div className="col-md-6 item text">
                    <h3>Your membership plan, better.</h3>
                    <p styleName="footer-item">Easily create, customize, and automate your in-house membership plan with DentalHQ.</p>
                    <p styleName="footer-item">Sign up today. Revolutionize your practice tomorrow.</p>
                </div>
                <div className="col-sm-6 col-md-3 item contact">
                    <h3>Contact DentalHQ</h3>
                    <ul>
                        <li><a href="mailto: hq@dentalhq.com">hq@dentalhq.com</a></li>
                        <li>833-222-HQ4U (4748)</li>
                        <li>8311 Brier Creek Pkwy,</li>
                        <li>Raleigh, NC 27617</li>
                    </ul>
                </div>
                <div className="col-sm-6 col-md-3 item">
                    <h3>Helpful links</h3>
                    <ul>
                        <li><a href="https://www.dentalhq.com/blog">DentalHQ Blog</a></li>
                        <li><a href="/patients">Looking for a dentist?</a></li> 
                        <li><a href="/#burning-questions">Dentist FAQs</a></li>
                        <li><a href="/about">About DentalHQ</a></li>
                        <li><a href="https://dentalhq-uploads.s3.amazonaws.com/DentalHQ-affiliate-program-201907.pdf">Affiliate Program</a></li>
                    </ul>
                </div>
                <div className="col item social"><a href="https://www.facebook.com/dentalhq/" target="_blank"><i className="icon ion-social-facebook"></i></a><a href="https://twitter.com/Dental_HQ" target="_blank"><i className="icon ion-social-twitter"></i></a><a href="https://www.linkedin.com/company/11333322/" target="_blank"><i className="icon ion-social-linkedin"></i></a></div>
            </div>
            <p styleName="copyright">© DentalHQ &nbsp;| &nbsp;<a href="https://app.dentalhq.com/terms">Terms and Conditions</a>&nbsp; | &nbsp;<a href="https://app.dentalhq.com/privacy">Privacy Policy</a></p>
        </div>
    </footer> 
</div>*/}
</div>
    );
  }
}
